import { useContext, useEffect, useState } from "react";
import {
  BusinessUseHomeContainer,
  BusinessUseHomeInputWrapper,
} from "./BusinessCollection.style";
import { Input, InputWithAdornment } from "components/reusable/input/Inputs";
import { Button } from "components/reusable/button/Button";
import AdditionalNotes from "../../modals/AdditionalNotes";
import ValidateTaxModal from "../../modals/ValidateTaxModal";
import { HeadingFive } from "components/reusable/typography/Typography.style";
import { useFormik } from "formik";
import {
  businessUseHomeBottomFields,
  businessUseHomeTopFields,
} from "data/clientData/generalBusiness";
import { apiReq } from "services/Requests";
import { API_ROUTES } from "utils/apiRoutes.constant";
import { SyncLoader } from "react-spinners";
import { toast } from "react-toastify";
import { PageLoaderContext } from "context/PageLoaderProvider";

const infoToast = (message = "") => toast.info(message);
const errorToast = (message = "") => toast.error(message);

const BusinessUseHome = ({ rowData, setCurrentTab }) => {
  const clientId = localStorage.getItem("clientId");

  const generalBusinessMainId = localStorage.getItem("generalBusinessMainId");
  const generalId = JSON.parse(localStorage.getItem("generalBusinessID"));
  const editForm = localStorage.getItem("editForm");
  const [Data, setData] = useState();
  const { setOpen } = useContext(PageLoaderContext);

  console.log(generalId, "generalId");

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      totalAreaOfHome: Data?.totalAreaOfHome || "",
      businessUseArea: Data?.businessUseArea || "",
      associationDues: Data?.associationDues || "",
      repairsAndMaintenance: Data?.repairsAndMaintenance || "",
      mortgageInterest: Data?.mortgageInterest || "",
      utilities: Data?.utilities || "",
      realEstateTaxes: Data?.realEstateTaxes || "",
      telephone: Data?.telephone || "",
      rent: Data?.rent || "",
      security: Data?.security || "",
      insurance: Data?.insurance || "",
    },
    onSubmit: async (values, { setSubmitting }) => {
      try {
        // Prepare data to be uploaded
        // const uploadData = { ...values, clientId, generalBusinessMainId};
        let uploadData;
        if (editForm === "true" && Data?._id) {
          uploadData = {
            ...values,
            clientId,
            businessUseOfHomeId: Data?._id,
          };
        } else {
          uploadData = {
            ...values,
            clientId,
            generalBusinessMainId: generalBusinessMainId || rowData?._id,
          };
        }
        const { data: { data = {} } = {} } = await apiReq(
          !Data?._id
            ? API_ROUTES.addBusinessUseHome
            : API_ROUTES.updateBusinessUseHome,
          "POST",
          uploadData
        );
        localStorage.setItem("businessUseOfHomeId", data?._id);

        infoToast(
          Data?._id
            ? "Business home info updated succesfully"
            : "Business home info saved succesfully"
        );
        setTimeout(() => {
          setCurrentTab(5);
        }, 1500);
      } catch (error) {
        errorToast(
          error?.message ||
            "An unexpected error occurred. Please try again later."
        );
      } finally {
        setSubmitting(false);
      }
    },
  });
  // console.log(
  //   rowData?._id,
  //   generalBusinessMainId,
  //   Data?._id,
  //   "adsdasdasdasdasasd"
  // );

  console.log(Data, "business use of home");

  useEffect(() => {
    const fetchdata = async () => {
      try {
        setOpen(true);
        const { data: { data = {} } = {} } = await apiReq(
          API_ROUTES.getGeneralBusinessByID +
            (rowData?._id || generalBusinessMainId),
          "POST",
          { clientId: clientId }
        );
        if (data) {
          setData(data?.businessUseOfHomeId);
        }
      } catch (error) {
        errorToast(
          error?.message ||
            "An unexpected error occurred. Please try again later."
        );
      } finally {
        setOpen(false);
      }
    };
    if (rowData?._id || generalBusinessMainId) fetchdata();
  }, [rowData?._id]);

  return (
    <>
      <BusinessUseHomeContainer>
        <HeadingFive color="#000" fontSize="18px" fontWeight="500">
          Business use of Home
        </HeadingFive>
        <BusinessUseHomeInputWrapper>
          {businessUseHomeTopFields.map(
            ({ label, name, placeHolder, width }, index) => (
              <Input
                label={label}
                name={name}
                value={formik.values[name]}
                onChange={formik.handleChange}
                placeholder={placeHolder}
                width={width}
                key={index}
              />
            )
          )}
          <InputWithAdornment
            label="Association Dues"
            name="associationDues"
            value={formik.values.associationDues}
            onChange={(e) => {
              let val = e.target.value.replace(/\D/g, "").slice(0, 9);
              formik.setFieldValue("associationDues", val);
            }}
            placeholder="Enter"
            width="49%"
          />
          {businessUseHomeBottomFields.map(
            ({ label, name, placeHolder, width }, index) => (
              <Input
                label={label}
                name={name}
                value={formik.values[name]}
                onChange={(e) => {
                  let val = e.target.value.replace(/\D/g, "").slice(0, 10);
                  formik.setFieldValue([name], val);
                }}
                placeholder={placeHolder}
                width={width}
                key={index}
              />
            )
          )}
        </BusinessUseHomeInputWrapper>
        {/* <Button
          text={
            formik.isSubmitting ? (
              <SyncLoader color={"#FFFFFF"} size={8} />
            ) : (
              "Submit"
            )
          }
          width="fit-content"
          fontSize="20px"
          padding="10px 40px"
          backgroundColor="#0B2558"
          onClick={formik.handleSubmit}
          alignSelf="flex-end"
        /> */}
        <Button
          // type="submit"
          text={
            formik.isSubmitting ? (
              <SyncLoader color={"#FFFFFF"} size={8} />
            ) : (
              "Next"
            )
          }
          disabled={formik.isSubmitting}
          width="fit-content"
          fontSize="20px"
          padding="10px 40px"
          backgroundColor="#0B2558"
          onClick={formik.handleSubmit}
          alignSelf="flex-end"
        />
      </BusinessUseHomeContainer>
    </>
  );
};

export default BusinessUseHome;
